import { gql } from "@apollo/client";

export const CONTEXTO_PUNTO_VENTA_EVENTO = gql`
  query contextoPuntoVentaEvento($comprador: CompradorEventoInput) {
    contextoPuntoVentaEvento(
      comprador: $comprador
    ) {
      habilitado
      porcentajeDescuentoEvento
      evento {
        id
        nombre
        inicio
        fin
        menuUniversitario
        menuUniversitarioPrecio descuentosClientes
      }
      vendedor {
        id
        nombre
      }
      sede {
        id
        nombre
      }
      productos {
        idProducto
        nombre
        idCategoria
        categoria
        precio
        precioCarta
        precioEvento
        orden
        esElaborado
      esMenuUniversitario
      }
      categorias
      mediosPago {
        codigo
        etiqueta
        requiereConfirmacionVendedor
        recomendado
      }
      vouchersFisicos {
        idVoucher
        grupo
        tipo
        idProducto
        producto
        idCategoria
        categoria
        valorPieza
        presupuesto
        saldo
        saldoDiario
      }
      avisos {
        codigo
        mensaje
      }
    }
  }
`;

export const VALIDAR_DISPONIBILIDAD_PRODUCTOS_EVENTO = gql`
  query validarDisponibilidadProductosEvento(
    $productos: [DisponibilidadProductoBatchInput!]!
    $idSucursal: ID
  ) {
    validarDisponibilidadProductos(productos: $productos, idSucursal: $idSucursal) {
      idProducto
      cantidad
      ok
      cantidadDisponible
    }
  }
`;

export const VENTAS_RECIENTES_EVENTO = gql`
  query ventasRecientesEvento($soloMias: Boolean, $limite: Int) {
    ventasRecientesEvento(soloMias: $soloMias, limite: $limite) {
      idPedido
      idVenta
      nroPedido
      estado
      medioPago
      voucher
      descuento
      descuentoVoucher
      descuentoEventoMasivo
      total
      unidades
      dni
      idCliente
      creadaEl
      anulada
    }
  }
`;

// Documento autoritativo para imprimir. Se pide igual al cerrar y al reimprimir
// para que los dos caminos impriman lo mismo.
export const DOCUMENTOS_IMPRESION_FIELDS = gql`
  fragment DocumentosImpresionFields on DocumentosImpresionVentaEvento {
    idPedido
    estadoFiscal
    emisor {
      nombre
      razonSocial
      cuit
      domicilio
      condicionIva
      ingresosBrutos
      inicioActividades
      puntoVenta
    }
    factura {
      tipo
      tipoComprobante
      numero
      puntoVenta
      fecha
      cliente
      tipoDocumento
      tipoDocumentoNombre
      numeroDocumento
      importeGravado
      importeIva
      cae
      caeVencimiento
      qr
    }
    pedido {
      idPedido
      idVenta
      nroPedido
      fecha
      evento
      vendedor
      unidades
      subtotal
      descuento
      descuentoVoucher
      descuentoEventoMasivo
      total
      voucher
      observaciones
    }
    lineas {
      idDetalle
      idProducto
      nombre
      cantidad
      precioUnitario
      subtotal
      esElaborado
      esMenuUniversitario
      esMenuUniversitario
      observacion
    }
    comanderaDestino {
      id
      printName
      habilitado
    }
  }
`;

export const DOCUMENTOS_IMPRESION_VENTA_EVENTO = gql`
  query documentosImpresionVentaEvento($idPedido: ID!) {
    documentosImpresionVentaEvento(idPedido: $idPedido) {
      ...DocumentosImpresionFields
    }
  }
  ${DOCUMENTOS_IMPRESION_FIELDS}
`;

export const INICIAR_VENTA_EVENTO = gql`
  mutation iniciarVentaEvento(
    $claveIdempotencia: String!
    $items: [VentaEventoItemInput!]!
    $medioPago: String
    $confirmadoPorVendedor: Boolean
    $dni: String
    $comprador: CompradorEventoInput
    $idVoucher: ID
    $observaciones: String
    $totalEsperado: Float
    $importeCobroEsperado: Float
  ) {
    iniciarVentaEvento(
      claveIdempotencia: $claveIdempotencia
      items: $items
      medioPago: $medioPago
      confirmadoPorVendedor: $confirmadoPorVendedor
      dni: $dni
      comprador: $comprador
      idVoucher: $idVoucher
      observaciones: $observaciones
      totalEsperado: $totalEsperado
      importeCobroEsperado: $importeCobroEsperado
    ) {
      idPedido
      idVenta
      nroPedido
      estado
      total
      descuento
      descuentoVoucher
      descuentoEventoMasivo
      reutilizada
      documentosImpresion {
        ...DocumentosImpresionFields
      }
    }
  }
  ${DOCUMENTOS_IMPRESION_FIELDS}
`;

export const BUSCAR_COMPRADOR_EVENTO = gql`
  query buscarCompradorEvento($dni: String!) {
    buscarCompradorEvento(dni: $dni) {
      encontrado
      dni
      idCliente
      nombre
      apellido
      esComunidadUpro
      appUsuario
      coincidencias
    }
  }
`;

// El buscador unificado es la misma fuente que usa el modulo de Menu
// Universitario. La pantalla del evento filtra luego por DNI exacto para no
// convertir esta consulta en una busqueda parcial por nombre u otros campos.
export const BUSCAR_USUARIOS_UNIFICADOS_EVENTO = gql`
  query buscarUsuariosUnificadosEvento($searchTerm: String!) {
    searchUnifiedUsers(searchTerm: $searchTerm, uso: "POS_EVENTO") {
      id
      nombre
      apellido
      dni
      tipoUser
      appUsuario
      tipoApp
    }
  }
`;
